var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWarning1X(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "21px",
    height: "21px",
    viewBox: "0 0 21 21",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "F6100199-4055-42B7-97AF-FF6936E43DB4@1x") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    d: "M0.505621098,19.6493965 L7.61859019,0.649396514 C7.76480858,0.258821293 8.13806644,-5.96779288e-13 8.55511419,-5.96855898e-13 L12.4516654,-5.96855898e-13 C12.8688201,-5.96932528e-13 13.2421501,0.258952108 13.3882918,0.649670202 L20.4949312,19.6496702 C20.688413,20.1669547 20.4259191,20.7431446 19.9086346,20.9366264 C19.7965886,20.9785354 19.677932,21 19.5583048,21 L1.44214509,21 C0.889860344,21 0.442145094,20.5522847 0.442145094,20 C0.442145094,19.8802746 0.463644965,19.7615222 0.505621098,19.6493965 Z M10.5,17.71875 C9.59134615,17.71875 8.859375,16.9867788 8.859375,16.078125 C8.859375,15.1694712 9.59134615,14.4375 10.5,14.4375 C11.4086538,14.4375 12.140625,15.1694712 12.140625,16.078125 C12.140625,16.9867788 11.4086538,17.71875 10.5,17.71875 Z M11.8125,13.125 L9.1875,13.125 L9.1875,6.5625 L11.8125,6.5625 L11.8125,13.125 Z",
    id: "path-1"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "path-3",
    x: 0,
    y: 0,
    width: 21,
    height: 21
  }), /*#__PURE__*/React.createElement("filter", {
    x: "-22.9%",
    y: "-20.0%",
    width: "145.7%",
    height: "145.7%",
    filterUnits: "objectBoundingBox",
    id: "filter-4"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dx: 0,
    dy: 0.3,
    in: "SourceAlpha",
    result: "shadowOffsetOuter1"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.6,
    in: "shadowOffsetOuter1",
    result: "shadowBlurOuter1"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0   0 0 0 0 0   0 0 0 0 0  0 0 0 0.15 0",
    type: "matrix",
    in: "shadowBlurOuter1",
    result: "shadowMatrixOuter1"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 0,
    dy: 0.6,
    in: "SourceAlpha",
    result: "shadowOffsetOuter2"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.5,
    in: "shadowOffsetOuter2",
    result: "shadowBlurOuter2"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0   0 0 0 0 0   0 0 0 0 0  0 0 0 0.2 0",
    type: "matrix",
    in: "shadowBlurOuter2",
    result: "shadowMatrixOuter2"
  }), /*#__PURE__*/React.createElement("feMerge", null, /*#__PURE__*/React.createElement("feMergeNode", {
    in: "shadowMatrixOuter1"
  }), /*#__PURE__*/React.createElement("feMergeNode", {
    in: "shadowMatrixOuter2"
  }))))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Symbols",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "CondoGo:-Icon-Library",
    transform: "translate(-36.000000, -109.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Message/...-Filled/Warning",
    transform: "translate(36.000000, 109.000000)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Icon/feedback-Warning"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Icon-Color",
    mask: "url(#mask-2)"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "black",
    fillOpacity: 1,
    filter: "url(#filter-4)",
    xlinkHref: "#path-3"
  }), /*#__PURE__*/React.createElement("use", {
    fill: "#0E51D8",
    fillRule: "evenodd",
    xlinkHref: "#path-3"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWarning1X);
export default __webpack_public_path__ + "static/media/Warning@1x.44e1a5dc1299ceeb3c21a46b7e52993e.svg";
export { ForwardRef as ReactComponent };